;(function module() {
  angular.module('app.ui.form.ctrls').controller('AdminProfileController', [
    '$location',
    '$scope',
    'usSpinnerService',
    'logger',
    'userService',
    'CandidateProfileApi',
    'SharedApi',
    'AdminProfileApi',
    function controller(
      $location,
      $scope,
      usSpinnerService,
      logger,
      userService,
      CandidateProfileApi,
      SharedApi,
      AdminProfileApi
    ) {
      let vm = this

      vm.uploadProfilePicture = async file => {
        if (file.length > 0) {
          vm.startSpin('spinner-dp')
          let formData = new FormData()
          formData.append('file', file[0])
          const {
            data: profilePicture,
          } = await CandidateProfileApi.uploadProfilePhoto(vm.user.id, formData)
          vm.user.profilePicture = profilePicture
          vm.user.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/user/${vm.user.id}/photo/${vm.user.profilePicture}`
          vm.stopSpin('spinner-dp')
          $scope.$apply()
        }
      }

      vm.deleteProfilePic = async () => {
        vm.startSpin('spinner-dp')

        await CandidateProfileApi.deleteProfilePhoto(vm.user.id)
        vm.user.profilePicture = undefined
        vm.user.logoSrc = `images/defaultPic.jpg`

        vm.stopSpin('spinner-dp')
        logger.notify('success', 'Successfully removed')
        $scope.$apply()
      }

      const errorHandler = response => {
        const USER_NOT_LOGGED_IN = 440

        if (response.status === USER_NOT_LOGGED_IN) $location.url('/signin')
        else logger.notify('error', 'update Failed!')
      }

      const resetEditObjectForForm = () => {
        let user = vm.user
        angular.extend(vm.adminUser, {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phone: user.phone,
        })
      }

      function createEditObject() {
        vm.adminUser = {}
        resetEditObjectForForm()
        vm.resetSignature()
      }

      vm.startSpin = spinnerID => {
        if (!vm.spinnerActive) {
          usSpinnerService.spin(spinnerID)
          vm.spinnerActive = true
        }
      }

      vm.stopSpin = spinnerID => {
        if (vm.spinnerActive) {
          usSpinnerService.stop(spinnerID)
          vm.spinnerActive = false
        } else {
          usSpinnerService.stop(spinnerID)
        }
      }

      vm.updateInfo = async () => {
        const adminUser = vm.adminUser

        const request = {
          firstName: adminUser.firstName ? adminUser.firstName : '',
          lastName: adminUser.lastName ? adminUser.lastName : '',
          email: adminUser.email,
          phone: adminUser.phone ? adminUser.phone : '',
        }
        if (request.firstName === '') {
          logger.notify('error', 'First Name is Required')
        } else if (request.lastName === '') {
          logger.notify('error', 'Last Name is Required')
          // eslint-disable-next-line no-negated-condition
        } else if (!request.email) {
          logger.notify('error', 'Email is Required')
        } else {
          try {
            const updatedUser = await CandidateProfileApi.updateUserData(
              vm.user.id,
              request
            )

            if (updatedUser && updatedUser.status === 200) {
              vm.user = updatedUser.data
              vm.user.logoSrc = `images/defaultPic.jpg`
              if (vm.user.profilePicture)
                vm.user.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/user/${vm.user.id}/photo/${vm.user.profilePicture}`
              vm.toggleEditDetailsForm()
              logger.notify('success', 'Successfully updated')
            }
          } catch (error) {
            logger.notify('error', error.data.message)
          }

          $scope.$applyAsync()
        }
      }

      vm.updateSignature = async () => {
        const adminUser = vm.adminUser
        const request = {
          signature: adminUser.signature,
        }
        // eslint-disable-next-line no-negated-condition
        const updatedSignature = await AdminProfileApi.updateAgentSignature(
          vm.user.id,
          request
        )

        if (updatedSignature.status === 201) {
          vm.user.signature = updatedSignature.data.signature

          vm.toggleEditDetailsForm()
          logger.notify('success', 'Successfully updated')
        } else {
          errorHandler(updatedSignature)
        }
      }

      vm.resetSignature = () => {
        angular.extend(vm.adminUser, {signature: vm.user.signature})
      }

      vm.toggleEditDetailsForm = () => {
        vm.showEditForm = !vm.showEditForm
        resetEditObjectForForm()
      }

      vm.initializeAdminProfile = async () => {
        vm.startSpin('spinner-dp')

        vm.user = await userService.getUser()

        const agent = await AdminProfileApi.getAgentSignature(vm.user.id)

        vm.user.signature = agent ? agent.data.signature : ''
        if (vm.user.profilePicture)
          vm.user.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/user/${vm.user.id}/photo/${vm.user.profilePicture}`
        createEditObject()

        vm.stopSpin('spinner-dp')
      }

      vm.initializeAdminProfile()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/admin-profile/admin-profile.ctrl.js